import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "filter cog outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-filter-cog-outline',
    templateUrl: './icon-filter-cog-outline.component.html',
    styleUrls: ['./icon-filter-cog-outline.component.scss'],
    standalone: false
})
export class IconFilterCogOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
